import { Card } from '../ui/Card'

interface UpcomingItem {
  label: string
  sub: string
  color: string
}

interface WidgetKommendeProps {
  items: UpcomingItem[]
  loading: boolean
  editMode?: boolean
}

export function WidgetKommende({ items, loading, editMode }: WidgetKommendeProps) {
  return (
    <Card
      padding="none"
      style={editMode ? { border: '1.5px dashed #4f46e5', background: '#fafbff' } : undefined}
    >
      <WidgetHeader title="Kommende handlinger" />
      <div style={{ padding: '10px 16px' }}>
        {loading ? (
          <div style={{ color: '#94a3b8', fontSize: 12 }}>Henter…</div>
        ) : items.length === 0 ? (
          <div style={{ color: '#94a3b8', fontSize: 12, padding: '8px 0' }}>Ingen kommende handlinger.</div>
        ) : (
          items.map((item, i) => (
            <div
              key={item.label + item.sub}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8,
                padding: '6px 0',
                borderBottom: i < items.length - 1 ? '1px solid #f8fafc' : 'none',
              }}
            >
              <div style={{
                width: 6, height: 6, borderRadius: '50%',
                background: item.color, marginTop: 4, flexShrink: 0,
              }} />
              <div>
                <div style={{ color: '#0f172a', fontSize: 12, fontWeight: 500 }}>{item.label}</div>
                <div style={{ color: '#94a3b8', fontSize: 11 }}>{item.sub}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </Card>
  )
}

interface WidgetHeaderProps {
  title: string
}

function WidgetHeader({ title }: WidgetHeaderProps) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px 8px', borderBottom: '1px solid #f1f5f9',
    }}>
      <span style={{ fontWeight: 600, fontSize: 13, color: '#0f172a' }}>{title}</span>
    </div>
  )
}

export { WidgetHeader }
